/* global VXConfig */
import PropTypes from 'prop-types';
import { Component } from 'react';
import Constants, { getTypeByColor } from './Constants';
import Flux from '../../flux/Flux';
import Alert, { BUTTON } from '../Alert/Alert';

export default class StatusBarGuestCancelationOfferError extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		if (!this.props.isVisible) {
			return null;
		}

		let zendeskLink = 'https://visitxbv.zendesk.com/hc/';
		if (VXConfig.language === Flux.Constants.Languages.DE) {
			zendeskLink += 'de';
		} else {
			zendeskLink += 'en-us';
		}
		return (
			<Alert
				type={getTypeByColor(this.props.barColor)}
				text={this.props.msgOutro}
				buttons={[
					{
						type: BUTTON.PRIMARY,
						text: this.props.btnLabel,
						onClick: () => {
							window.open(zendeskLink, '_blank');
						},
					},
				]}
			/>
		);
	}
}

StatusBarGuestCancelationOfferError.propTypes = {
	barColor: PropTypes.string.isRequired,
	msgOutro: PropTypes.string.isRequired,
	btnLabel: PropTypes.string.isRequired,
	isVisible: PropTypes.bool.isRequired,
};

StatusBarGuestCancelationOfferError.defaultProps = {
	barColor: Constants.BARCOLOR_WHITE,
};
